'use strict';

var REACT_BASE_PATH = window.location.port === '3001'
  ? 'http://localhost:3000'
  : '/v2/web/index.html';

function reactUrl(path) {
  return REACT_BASE_PATH + '#' + path;
}

var ReactNavigationService = /*@ngInject*/ function($window, $location) {
  this.goToSearch = function(query) {
    var term = query || '*';
    $window.location.assign(reactUrl('/search?term=' + encodeURIComponent(term) + '&type=All'));
  };

  this.goToJobDetail = function(jobId) {
    $window.location.assign(reactUrl('/job/' + jobId));
  };

  this.goToProductDetail = function(productId) {
    $window.location.assign(reactUrl('/product/' + productId));
  };

  this.goToQAQueue = function() {
    var tab = $location.search().tab || 'unassigned';
    $window.location.assign(reactUrl('/queues/qa?tab=' + tab));
  };

  this.goToPostProdQueue = function() {
    $window.location.assign(reactUrl('/queues/post-prod?tab=unassigned'));
  };

  this.goToAdmin = function(section) {
    $window.location.assign(reactUrl('/admin/' + section));
  };

  this.goToHome = function() {
    $window.location.assign(reactUrl('/'));
  };

  this.buildUrl = reactUrl;
};

module.exports = ReactNavigationService;
